import { ModelBasedVisual } from "../../../visuals/ModelBasedVisual";
import { BaseAgent } from "./BaseAgent";

export class VehicleAgent extends BaseAgent {
  constructor(visual: ModelBasedVisual) {
    super(visual);
    this.maxSpeed = 4;
  }
}